<template>
  <div class="flex mt-3" />
  <div class="grid grid-cols-3 gap-2">
    <QuantitySelector
      v-for="(value, index) in sortedValues"
      :id="value.id"
      :key="index"
      :label="value.name"
      :min-value="minimumValue(value)"
      :max-value="props.maximum"
      :data-testid="`counter-option-${value.id}`"
      :allow-increase="allowIncrease"
      @change="onChanged"
    />
  </div>
  <label
    v-if="displaySelectorError && maxErrorMessage"
    class="font-light text-sm mt-1 text-red-500"
  >
    {{ maxErrorMessage }}
  </label>
  <label v-if="displayEveryoneMustBePresent" class="font-normal text-sm mt-1">
    Everyone must be present when boarding.
  </label>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useOrderStore } from '@/stores/order'

import QuantitySelector from '@/components/inputs/QuantitySelector.vue'

const emit = defineEmits(['change'])

const props = defineProps({
  values: {
    type: Array as () => ProductOptionValue[],
    default: () => []
  },
  maximum: {
    type: Number,
    required: false,
    default: Infinity
  },
  maxErrorMessage: {
    type: String,
    required: false,
    default: ''
  }
})

const orderStore = useOrderStore()
const { passesQuantity, createIndividualPasses } = storeToRefs(orderStore)
const displaySelectorError = ref(false)
const displayEveryoneMustBePresent = computed(() => !createIndividualPasses.value)
const sortedValues = computed(() =>
  [...props.values].sort((val1, val2) => val1.priority - val2.priority)
)
const allowIncrease = computed<boolean>(
  () => !createIndividualPasses.value || passesQuantity.value < props.maximum
)

function minimumValue(value: ProductOptionValue) {
  const minSetting = value.settings.find((setting: any) => setting['minimum'] !== undefined)
  return (minSetting && minSetting['minimum']) || 0
}

function onChanged(optionValueId: string, newValue: number, oldValue: number) {
  emit('change', optionValueId, newValue)
  displaySelectorError.value =
    createIndividualPasses.value && newValue == oldValue && passesQuantity.value == props.maximum
}
</script>

<style scoped></style>
